import Wrapper from "../../Wrapper";

 const SalesCalender = ()=>{
     return (
         <>
         <Wrapper>
            <h3 style={{textAlign: "center",position: "relative", top: "50px", color:"#bf2527"}}>Sales Calender</h3>
         </Wrapper>
         </>
     );
 }
 export default SalesCalender;